import React, { memo, forwardRef } from "react";
const SvgAdditionalCompound = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <circle cx={16} cy={16} r={2} fill="#717171" />
      <rect width={10} height={14} x={20} y={9} fill="#D9D9D9" rx={2} />
      <rect
        width={9}
        height={13}
        x={2.5}
        y={9.5}
        stroke="#717171"
        strokeDasharray="2 2"
        rx={1.5}
      />
    </svg>
  );
});
SvgAdditionalCompound.displayName = "SvgAdditionalCompound";
const MemoForwardRef = memo(SvgAdditionalCompound);
export default MemoForwardRef;
